import React from "react";
import "./FeatureCard.css";

const FeatureCard = ({ iconColor, title, description }) => {
    return (
        <div className="feature-card">
            <div>
                <div className="card-header">
                    <div
                        className="card-icon"
                        style={{ backgroundColor: iconColor }}
                    ></div>
                    <h3 className="card-title">
                        {title.split(" ").slice(0, 2).join(" ")}
                        <br />
                        {title.split(" ").slice(2).join(" ")}
                    </h3>
                </div>

                <p className="card-description">{description}</p>
            </div>
        </div>
    );
};

export default FeatureCard;
